<!-- section start -->

<div>
    <section class="section_one">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="ibox">
                        <div style="padding: 5px 10px;" class="d-flex gap-2">
                            <!--BUSINESS TYPE -->

                            <div class="dropdown pt-2 ">
                                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false" (click)="focusSearchInput()">
                                    <span> {{ businessName || 'Business Type' }}</span>
                                </a>
                                <ul class="dropdown-menu campus-details">
                                    <li class="list_campus1">
                                        <ng-container *ngFor="let campus of business">
                                            <ul class="overall_Detail" (click)="selectBusinessType(campus)"
                                                [class.selected]="businessName===campus">
                                                <li class="campus_right">
                                                    {{campus}}
                                                </li>

                                                <li>
                                                    <span *ngIf="businessName===campus"><i
                                                            class="fa fa-check right_check"></i></span>
                                                </li>
                                            </ul>
                                        </ng-container>
                                    </li>
                                </ul>
                            </div>

                            <!--END BUSINESS TYPE -->
                            <!-- STATE DROPDOWN -->

                            <div class="dropdown pt-2 ">
                                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false" (click)="focusSearchInput()">

                                    <span>{{ stateNames || 'State Name' }}</span>
                                </a>
                                <ul class="dropdown-menu campus-details">
                                    <li class="d-flex align-items-center">
                                        <!-- <input type="text" class="form-control" placeholder="Search..."
                                            #searchInputcampus (keyup)="campusSearch($event)"
                                            [(ngModel)]="stateQuery" /> -->
                                    </li>
                                    <li class="list_campus">
                                        <ng-container
                                            *ngIf="CityDetailsName?.length>0; else noDatafound"></ng-container>
                                        <ng-container *ngFor="let data of CityDetailsName">
                                            <ul class="overall_Detail" (click)="selectState(data)"
                                                [class.selected]="data.stateName===stateNames">
                                                <li class="campus_right">
                                                    {{data.stateName}}
                                                </li>
                                                <li>
                                                    <span *ngIf="data.stateName===stateNames"><i
                                                            class="fa fa-check right_check"></i></span>
                                                </li>

                                            </ul>
                                        </ng-container>
                                        <!-- 🔹 Show when no data -->
                                        <ng-template #noDatafound>
                                            <div class="text-center text-muted p-2">No cities found</div>
                                        </ng-template>
                                    </li>
                                </ul>
                            </div>

                            <!-- END STATE DROPDOWN -->

                            <!-- CITY DROPDOWN -->

                            <!-- <div class="dropdown pt-2 ">
                                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false" (click)="focusSearchInput()">
                                    City Name
                                </a>
                                <ul class="dropdown-menu campus-details">
                                    <li class="d-flex align-items-center">
                                        <input type="text" class="form-control" placeholder="Search..."
                                            #searchInputcampus (keyup)="campusSearch($event)"
                                            [(ngModel)]="campusQuery" />
                                    </li>
                                    <li class="list_campus">
                                        <ng-container>
                                            <ul class="overall_Detail">

                                                <li class="campus_right">

                                                </li>

                                            </ul>
                                        </ng-container>
                                    </li>
                                </ul>
                            </div> -->

                            <!-- END CITY DROPDOWN -->

                            <!-- CAMPUS DROPDOWN -->

                            <!-- <div class="dropdown pt-2 ">
                                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false" (click)="focusSearchInput()">
                                    Campus Name
                                </a>
                                <ul class="dropdown-menu campus-details">
                                    <li class="d-flex align-items-center">
                                        <input type="text" class="form-control" placeholder="Search..."
                                            #searchInputcampus (keyup)="campusSearch($event)"
                                            [(ngModel)]="campusQuery" />
                                    </li>
                                    <li class="list_campus">
                                        <ng-container>
                                            <ul class="overall_Detail">

                                                <li class="campus_right">

                                                </li>

                                            </ul>
                                        </ng-container>
                                    </li>
                                </ul>
                            </div> -->

                            <!-- END CAMPUS DROPDOWN -->

                            <!-- BUILDING DROPDOWN -->

                            <!-- <div class="dropdown pt-2 ">
                                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown"
                                    aria-expanded="false" (click)="focusSearchInput()">
                                    Building Name
                                </a>
                                <ul class="dropdown-menu campus-details">
                                    <li class="d-flex align-items-center">
                                        <input type="text" class="form-control" placeholder="Search..."
                                            #searchInputcampus (keyup)="campusSearch($event)"
                                            [(ngModel)]="campusQuery" />
                                    </li>
                                    <li class="list_campus">
                                        <ng-container>
                                            <ul class="overall_Detail">

                                                <li class="campus_right">

                                                </li>

                                            </ul>
                                        </ng-container>
                                    </li>
                                </ul>
                            </div> -->

                            <!-- END BUILDING DROPDOWN -->

                        </div>
                        <div class="ibox-content">
                            <mat-card>
                                <ng-container *ngIf="dataAvailable; else noData">
                                    <!--- no data-->
                                    <div class="searchpaginator">
                                        <div class="table_search">
                                            <input type="text" class="form-control" (keyup)="applyFilter($event)"
                                                [(ngModel)]="filterValue"
                                                placeholder="Search By Building Name or Fusion Code or IP Address or Model No or HTTP No or RTSP No or HD Status">
                                        </div>
                                        <div>
                                            <mat-paginator [pageSize]="100"
                                                [pageSizeOptions]="[100, 200, 300, 400]"></mat-paginator>
                                        </div>
                                        <span (click)="exportAsXLSX()"><img
                                                src="../../assets/image/vscode-icons_file-type-excel.svg"
                                                class="excel_sheet" alt=""></span>
                                    </div>
                                    <div class="table-responsive">
                                        <mat-card-content>
                                            <table mat-table [dataSource]="totalcctvdata" matSort class="table_resize">
                                                <ng-container matColumnDef="buildingFusionCode">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        class="resizer" appResizableColumns>Fusion Code
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.buildingFusionCode || 'N/A'}}
                                                    </td>
                                                </ng-container>

                                                <!-- <ng-container matColumnDef="stateName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        class="resizer" appResizableColumns>State Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.stateName || 'N/A'}}
                                                    </td>
                                                </ng-container> -->
                                                <ng-container matColumnDef="sNo">
                                                    <th mat-header-cell *matHeaderCellDef>S.No</th>
                                                    <td mat-cell *matCellDef="let element; let i = index">
                                                        {{ (totalcctvdata.paginator?.pageIndex || 0) *
                                                        (totalcctvdata.paginator?.pageSize || 0) + i + 1 }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="cityName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        class="resizer" appResizableColumns>City Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.cityName || 'N/A'}}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="buildingName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        class="resizer" appResizableColumns>Building Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        (click)="alldata(row)"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span class="notworking_txt"> {{row.buildingName |
                                                            uppercase}}</span>
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="ipAddress">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> IP Address
                                                    </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}"
                                                        style="text-align: left;">
                                                        {{row.ipAddress}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="httpPortNo">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> Server Port No </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}"
                                                        style="text-align: right;">
                                                        {{row.httpPortNo}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="rtspPortNo">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> RTSP No</th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}"
                                                        style="text-align: right;">
                                                        {{row.rtspPortNo}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="dvrModelNumber">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> Model No & Serial No
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.dvrModelNumber}}
                                                    </td>
                                                </ng-container>
                                                <!-- <ng-container matColumnDef="serialNumber">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Serial Number
                                                    </th>
                                                    <td mat-cell *matCellDef="let element" style="text-align: left;"
                                                        [ngClass]="{'highlighted': isSelected(element)}">
                                                        {{element.serialNumber}}
                                                    </td>
                                                </ng-container> -->
                                                <ng-container matColumnDef="dvrSystemDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> DVR Current
                                                        Date
                                                    </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <!-- {{row.dvrSystemDate ||'N/A'}} -->
                                                        <ng-container
                                                            *ngIf="row.dvrPresentWorkingStatus === 'CONNECTED'">
                                                            <span>{{row.dvrSystemDate}}</span>
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="row.dvrPresentWorkingStatus !=='CONNECTED'">
                                                            <span></span>
                                                        </ng-container>

                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="totalCamerasInstalled">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> T I </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.totalCamerasInstalled}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="totalConnected">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> W </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span class="working_txt">{{row.totalConnected}}</span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="totalNotConnected">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> N W </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span class="notworking_txt">{{row.totalNotConnected}}</span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="dvrCheckDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns>DVR Check Date
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span>{{row.dvrCheckDate || 'N/A'}}</span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="hdStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns>HD Status
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span>{{row.hdStatus || '-'}}</span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="hdCapacity">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns>HD Capacity
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span>{{row.hdCapacity || '-'}}</span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="dvrPresentWorkingStatus">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> Status </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <ng-container
                                                            *ngIf="row.dvrPresentWorkingStatus === 'CONNECTED'">
                                                            <label class="txt_online">
                                                                <img src="../../assets/image/mdi_tick-circle.svg"
                                                                    class="cctvonline" alt="cctvonline">ONLINE
                                                            </label>
                                                        </ng-container>
                                                        <ng-container
                                                            *ngIf="row.dvrPresentWorkingStatus !== 'CONNECTED'">
                                                            <label class="txt_offline">
                                                                <img src="../../assets/image/carbon_close-filled.svg"
                                                                    class="cctvonline" alt="cctvoffline">OFFLINE
                                                            </label>
                                                        </ng-container>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="view">
                                                    <th mat-header-cell *matHeaderCellDef> View </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <button (click)="alldata(row)"
                                                            class="view_details">View</button>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="edit">
                                                    <th mat-header-cell *matHeaderCellDef> Edit </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <button (click)="editdata(row)"
                                                            class="view_details">Edit</button>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="displayedColumns  sticky: true">
                                                </tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                                <!-- Row shown when there is no matching data. -->
                                                <tr class="mat-row" *matNoDataRow>
                                                    <td class="mat-cell" class="not_matchdata" colspan="15">No data
                                                        matching the filter
                                                    </td>
                                                </tr>
                                            </table>
                                        </mat-card-content>
                                    </div>
                                </ng-container>
                            </mat-card>
                            <ng-template #noData>
                                <section class="section_one">
                                    <div class="cctvcouncelling__sec">
                                        <div class="councellist__flex">
                                            <div>
                                                <div class="nodata_center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../assets/image/nodata.png" alt="nodata"
                                                            class="nodata">
                                                    </figure>
                                                    <p class="no_data">No Data Found</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </ng-template>

                            <h3 class="working_list"> <span>
                                    Remarks:
                                    T.I=Total Installed;
                                    W=Working;
                                    N.W=NotWorking;
                                </span></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>


<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>